import React from "react";
import { Button } from "../Button";

import { useService } from "@/base/hooks/useService";

import { StorageService } from "@services/StorageService";
import saveDestination from "../../helpers/saveDestination";

import { ReactComponent as TwitchIcon } from "../../assets/ic-twitch-log-in.svg";

const TwitchLoginButton = (props) => {
  const storageService = useService(StorageService);

  const handleLogin = async () => {
    try {
      saveDestination(storageService);
      const url = new URL("https://id.twitch.tv/oauth2/authorize");
      url.searchParams.append(
        "client_id",
        import.meta.env.VITE_APP_TWITCH_CLIENT_ID,
      );
      url.searchParams.append(
        "redirect_uri",
        import.meta.env.VITE_APP_TWITCH_REDIRECT_URI,
      );
      url.searchParams.append("response_type", "code");
      url.searchParams.append("scope", "user:read:email");
      url.searchParams.append("force_verify", "true");
      window.location.href = url.toString();
    } catch (error) {
      console.error("Twitch login error:", error);
    }
  };

  return (
    <Button {...props} onClick={handleLogin}>
      <TwitchIcon />
    </Button>
  );
};

export default TwitchLoginButton;
